<template>
    <div style="height: 100%;">
      <div class="spin">
        <div
          style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"
        >
          <div>
            <img
              src="../assets/images/logo2.png"
              loading="lazy"
              style="height:100px;"
            />
          </div>
          <div
            style="display: flex; flex: 1; align-items: center; gap: 12px; justify-content: flex-end;"
          >
            <div
              style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);"
            >
              <img
                src="../assets/images/coin.png"
                width="22"
                alt="Coin"
              />
              <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
            </div>
            <span
              class="avatar"
              id="avatar"
              :style="{ 'background-image': `url(${pictureUrl})` }"
            ></span>
          </div>
        </div>
        <div
          style="position: absolute; top: 60px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              v-if="defaultOptionsOpen1"
              :options="defaultOptionsOpen1"
              :height="450"
              :width="450"
              v-on:animCreated="handleAnimationOpen1"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              v-if="defaultOptionsOpen2"
              :options="defaultOptionsOpen2"
              :height="450"
              :width="450"
              v-on:animCreated="handleAnimationOpen2"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              v-if="defaultOptionsOpen3"
              :options="defaultOptionsOpen3"
              :height="450"
              :width="450"
              v-on:animCreated="handleAnimationOpen3"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              v-if="defaultOptionsOpen4"
              :options="defaultOptionsOpen4"
              :height="450"
              :width="450"
              v-on:animCreated="handleAnimationOpen4"
            />
          </div>
          <div style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
            <lottie
              v-if="defaultOptionsCard"
              :options="defaultOptionsCard"
              :height="450"
              :width="450"
              v-on:animCreated="handleAnimationCard"
            />
            <div style="position: absolute; left: 3%; width: 90px; height: 50%; " @click="select('1')"></div>
            <div style="position: absolute; left: 27%; width: 90px; height: 50%; " @click="select('2')"></div>
            <div style="position: absolute; left: 50%; width: 90px; height: 50%; " @click="select('3')"></div>
            <div style="position: absolute; right: 3%; width: 90px; height: 50%; " @click="select('4')"></div>
          </div>
        </div>
        <!-- <div
          style="position: absolute; top: 300px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              :options="defaultOptions2Cut"
              :height="250"
              :width="250"
              v-on:animCreated="handleAnimation2Cut"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              :options="defaultOptions2Paper"
              :height="250"
              :width="250"
              v-on:animCreated="handleAnimation2Paper"
            />
          </div>
          <div
            style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
          >
            <lottie
              :options="defaultOptions2Hammer"
              :height="250"
              :width="250"
              v-on:animCreated="handleAnimation2Hammer"
            />
          </div>
        </div> -->
        <div
          :style="{
            position: 'absolute',
            top: '200px',
            'align-items': 'center',
            'justify-content': 'center',
            display: 'flex',
            left: '0',
            right: '0',
            display: showResult ? 'block' : 'none'
          }"
        >
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: win,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsWin" :height="550" :width="550"  v-on:animCreated="handleAnimationWin" /> -->
            <img src="../assets/images/win.png" />
          </div>
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: lose,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsLose" :height="550" :width="550"  v-on:animCreated="handleAnimationLose" /> -->
            <img src="../assets/images/lose.png" />
          </div>
          <div
            :style="{
              position: 'absolute',
              top: '0px',
              'align-items': 'center',
              'justify-content': 'center',
              display: draw,
              left: '0',
              right: '0'
            }"
          >
            <!-- <lottie :options="defaultOptionsDraw" :height="550" :width="550"  v-on:animCreated="handleAnimationDraw" /> -->
            <img src="../assets/images/draw.png" />
          </div>
        </div>
        
        <div
          style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <div
            style="display: flex; flex: 1; align-items: center; justify-content: center;"
          >
            <div
              style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;"
            >
              <span class="glow" ref="myBtn">
                {{ loadingtext }}
              </span>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </template>
  
  <script>
  import firebase, { firestore } from "firebase/app";
  import "firebase/database";
  import moment from "moment-timezone";
  import router from "./../router";
  import Lottie from "./lottie.vue";
  import { loadAnimation } from "@/services/lottieLoader";
  import liffService from "@/services/liff";
  // import * as animationWin from '../assets/win-game.json';
  // import * as animationLose from '../assets/lose-game.json';
  // import * as animationDraw from '../assets/draw-game.json';
  export default {
    name: "S1",
    async created() {
      const [animage, animage1, animage2, animage3, animage4] = await Promise.all([
        loadAnimation('poker/Card'),
        loadAnimation('poker/Open1'),
        loadAnimation('poker/Open2'),
        loadAnimation('poker/Open3'),
        loadAnimation('poker/Open4')
      ]);
      this.defaultOptionsCard = {
        animationData: animage,
        autoplay: false,
        loop: false
      };
      this.defaultOptionsOpen1 = {
        animationData: animage1,
        autoplay: false,
        loop: false
      };
      this.defaultOptionsOpen2 = {
        animationData: animage2,
        autoplay: false,
        loop: false
      };
      this.defaultOptionsOpen3 = {
        animationData: animage3,
        autoplay: false,
        loop: false
      };
      this.defaultOptionsOpen4 = {
        animationData: animage4,
        autoplay: false,
        loop: false
      };
      // const animagewin = animationWin.default;
      // this.defaultOptionsWin = {animationData: animagewin,autoplay:false,loop:false};
  
      // const animagelose = animationLose.default;
      // this.defaultOptionsLose = {animationData: animagelose,autoplay:false,loop:false};
  
      // const animagedraw = animationDraw.default;
      // this.defaultOptionsDraw = {animationData: animagedraw,autoplay:false,loop:false};
      // this.animWin.hide()
      // this.animLose.hide()
      // this.animDraw.hide()
    },
    components: {
      lottie: Lottie
    },
    data() {
      return {
        win: "none",
        lose: "none",
        draw: "none",
        showResult: false,
        pictureUrl: "",
        mycoin: 0,
        showLoading: true,
        isDisabled: true,
        percentage: 0,
        canOpen: false,
        loadingtext: "น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่",
        defaultOptionsCard: null,
        defaultOptionsOpen1: null,
        defaultOptionsOpen2: null,
        defaultOptionsOpen3: null,
        defaultOptionsOpen4: null,
        anim: null,
        animage1: null,
        animage2: null,
        animage3: null,
        animage4: null,
        userId: "",
        displayName: "",
        statusMessage: "",
        userKey: ""
      };
    },
    mounted() {
      // LIFF is already initialized by router guard
      this.loadUserData();
      // Animation logic moved to handlers
    },
    methods: {
      handleTouch (i){
        console.log(i);
      },
      select(select) {
        if(this.canOpen) {
            this.$confirm({
              message: `ยืนยันการเลือกไพ่?`,
              button: {
                yes: "OK",
                no: "Cancel"
              },
              callback: async confirm => {
                if (confirm) {
                  this.canOpen = false;
                  const com = Math.floor(Math.random() * 4);
                  this.anim.hide();
                  //0 = โพธิ์ดำ
                  //1 = ดอกจิก
                  //2 = โพธิ์แดง
                  //3 = ข้าวหลาม
                  let coin = 0;
                  let icon = '';
                  if (com === 0) {
                    this.animage1.show();
                    this.animage1.play();
                    coin = 20;
                    icon = '♠️';
                  } else if (com === 1) {
                    this.animage2.show();
                    this.animage2.play();
                    coin = 5;
                    icon = '♣️';
                  } else if (com === 2) {
                    this.animage3.show();
                    this.animage3.play();
                    coin = 15;
                    icon = '♥︎';
                  } else {
                    this.animage4.show();
                    this.animage4.play();
                    coin = 10;
                    icon = '♦︎';
                  }
                  firebase.firestore().collection("scratch").doc(this.userId +"-"+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
                        userId: this.userId,
                        createdate: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                        spin: coin,
                        value: coin
                  });
                  setTimeout(() => {
                    this.$confirm({
                        message: `ปังปุรีเย่!! คุณได้รับ ${coin} เหรียญ ${icon}`,
                        button: {
                          yes: "OK"
                        },
                        callback: async confirm => {
                          if (confirm) {
                            this.sendMessageLine(`ปังปุรีเย่!! คุณได้รับ ${coin} เหรียญ ${icon}`);
                          }
                        }
                      });
                  }, 2000);
                }
              }
            });
        }
      },
      handleAnimationCard: function(anim) {
        this.anim = anim;
        this.anim.play();
        setTimeout(() => {
          this.anim.goToAndPlay(0, true);
        }, 1000);
      },
      handleAnimationOpen1: function(anim) {
        this.animage1 = anim;
        this.animage1.hide();
      },
      handleAnimationOpen2: function(anim) {
        this.animage2 = anim;
        this.animage2.hide();
      },
      handleAnimationOpen3: function(anim) {
        this.animage3 = anim;
        this.animage3.hide();
      },
      handleAnimationOpen4: function(anim) {
        this.animage4 = anim;
        this.animage4.hide();
      },
      async sendMessageLine(text) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: text
          }
        ]);
        window.liff.closeWindow();
      },
      async sendMessageLine2(text) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: "♠︎ ♣︎ ♥︎ ♦︎" + text
          }
        ]);
      },
      async sendMessageLine3(text) {
        await window.liff.sendMessages([
          {
            type: "flex",
            altText: "ปังปุรีเย่!! คุณได้รับ " + text,
            contents: {
              type: "bubble",
              size: "micro",
              body: {
                type: "box",
                layout: "vertical",
                contents: [
                  {
                    type: "text",
                    text: "ยินดีด้วยค่ะ !",
                    color: "#CCCCCC",
                    size: "lg",
                    weight: "bold",
                    align: "center"
                  },
                  {
                    type: "image",
                    url:
                      "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                    position: "relative",
                    size: "sm"
                  },
                  {
                    type: "text",
                    text: "+" + text,
                    size: "sm",
                    color: "#CCCCCC",
                    align: "center",
                    weight: "bold"
                  }
                ],
                spacing: "xxl",
                margin: "none",
                action: {
                  type: "uri",
                  label: "action",
                  uri: "https://liff.line.me/2006378234-72e9GVNa/reward",
                  altUri: {
                    desktop: "https://liff.line.me/2006378234-72e9GVNa/reward"
                  }
                },
                background: {
                  type: "linearGradient",
                  angle: "0deg",
                  startColor: "#DD2476",
                  endColor: "#FF512F"
                }
              },
              styles: {
                footer: {
                  separator: true
                }
              }
            }
          }
        ]);
        window.liff.closeWindow();
      },
      async loadUserData() {
        if (!window.liff.isInClient()) {
          router.replace("/login");
        } else {
          // Get profile from centralized service (already fetched by router guard)
          const profile = liffService.profile;
          if (!profile) return;

          this.userId = profile.userId || "";
          this.pictureUrl = profile.pictureUrl || "none";
          this.displayName = profile.displayName ? profile.displayName : "none";
          this.statusMessage = profile.statusMessage
            ? profile.statusMessage
            : "none";
          if (this.userId) {
            const user = (
              await firebase
                .database()
                .ref(`/users`)
                .orderByChild("userId")
                .equalTo(this.userId)
                .once("value")
            ).val();
            if (user) {
              const u = user[Object.keys(user)[0]];
              this.mycoin = u.coins ? u.coins : 0;
              this.userKey = Object.keys(user)[0];
              this.sendMessageLine2(
                "สนใจเล่นไพ่ พลอยใสจัดการให้หน่อย 😘😘"
              );
              if (moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === "2026-03-27") {
                await firebase.firestore().collection("scratch").doc(this.userId +"-" +moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async snapshot => {
                    if (snapshot.exists) {
                      this.sendMessageLine(
                        "ลูกค้าเล่นไพ่ไปแล้วนะคะวันนี้ รอวันใหม่นะคะ 😘😘"
                      );
                    } else {
                     // this.canOpen= true;
                      await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                        let credit = 0;
                        snapshot.forEach((doc)=>{
                          credit += Number(doc.data().qty);
                        });
                        if(credit >= 500){
                          this.loadingtext = 'น้องออโต้พร้อมแล้วเล่นไพ่ ได้เลยค่ะ😘😘';
                          this.showLoading = true;
                          this.canOpen= true;
                        }else{
                          const less = 500-Number(credit);
                          this.loadingtext = `เติมเงินอีก ${less}(500) ได้เล่นเลยค่ะ!😘😘`;
                        }
                        // if(snapshot.size > 0){
                        //   this.loadingtext = 'น้องออโต้พร้อมแล้วเล่นไพ่ ได้เลยค่ะ😘😘';
                        //   this.showLoading = true;
                        //   this.canOpen= true;
                        // }else{
                        //   this.$confirm({
                        //     message: `คุณยังไม่ได้เติมเงินในเดือนนี้`,
                        //     button: {
                        //       yes: "OK"
                        //     },
                        //     callback: async confirm => {
                        //       if (confirm) {
                        //         this.sendMessageLine(`กรุณาเติมเงินก่อนถึงได้เล่นไพ่นะคะ!`);
                        //       }
                        //     }
                        //   });
                        // }
                      });
                    }
                  });
              } else {
                this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 27 March เท่านั้น!😘😘`;
              }
            } else {
              router.replace("/register");
            }
          }
          this.isDisabled = false;
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .wrapper {
    padding-left: 20%;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    padding-top: 50%;
    height: 100%;
  }
  .glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
  }
  
  @-webkit-keyframes glow {
    from {
      text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
        0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
  
    to {
      text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
        0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
  }
  .spin {
    padding: 0px;
    margin: 0px;
    overflow: hidden;
    height: 100%;
    /*background: rgb(255,204,92,1);
      background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
    background: linear-gradient(rgb(0, 0, 0), rgb(0, 0, 0));
    border-right: 2px solid #cbcbcb;
    background-size: 100% auto;
    background-position: center top;
    background-attachment: fixed;
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
  }
  </style>
  